export default __webpack_public_path__ + "static/media/brokerStepIcon2.979fd4cc.webp";